module.exports = __webpack_public_path__ + "img/3.925fdec7.png";